import script from "./FenXiangGuanPage.vue?vue&type=script&setup=true&lang=js"
export * from "./FenXiangGuanPage.vue?vue&type=script&setup=true&lang=js"

import "./FenXiangGuanPage.vue?vue&type=style&index=0&id=32859f85&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-32859f85"]])

export default __exports__